import {BaseRequestHeader, IHeadersManager} from '../../types';
import TokenManager from './TokenManager';

/**
 * HeadersManager
 */
class HeadersManager implements IHeadersManager {
  language: 'fr' | 'en';
  readonly tokenManager: TokenManager;

  /**
   * Constructor
   * @param language
   */
  constructor(tokenManager: TokenManager, language: 'fr' | 'en' = 'en') {
    this.language = language;
    this.tokenManager = tokenManager;
  }

  /**
   * Get the headers for the request
   */
  public getHeaders(): BaseRequestHeader {
    return {
      language: this.language,
      authorization: this.tokenManager.getToken(),
    } as BaseRequestHeader;
  }

  /**
   * Set the language
   * @param language
   */
  public setLanguage(language: 'fr' | 'en') {
    this.language = language;
  }
}

export default HeadersManager;
